"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleLocationInSet = void 0;
/**
 * @param {Set} selectedLocationIds
 * @param {String} id
 * @returns {Set}
 */
const toggleLocationInSet = (selectedLocationIds, id) => {
    const updates = new Set(selectedLocationIds);
    if (id != null) {
        updates.has(id) ? updates.delete(id) : updates.add(id);
    }
    return updates;
};
exports.toggleLocationInSet = toggleLocationInSet;
//# sourceMappingURL=ProviderLocations.utils.js.map